import React, { useEffect } from "react";
import AudienceMetricsChart from "./AudienceMetricsChart";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";

function AudienceByAge(props) {
    const chartLoading = props.chartDataLoading?.audience_metrics_by_age;
    const isNoData = props.pageStatus || Object.keys(props?.chartData?.audience_metrics_by_age || {}).length === 0;
    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    return (
        <>
            {chartLoading && <Loading />}

            {!isNoData && !chartLoading && (
                <AudienceMetricsChart
                    chartData={props.chartData?.audience_metrics_by_age}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                    graph_type={props.graph_type}
                />
            )}

            {isNoData && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}
export default AudienceByAge;
